import { actStatuses, Translate } from "../../../../Utils/TranslationUtils";
import ActStatusCircle from "../../../UIElements/StatusCircle";
import { dataFilterMatchModeOptions, findKeyByValue, formatCurrency, useEnumLabel } from "../../../../Utils/Utils";
import DateRowFilterTemplate from "../../../UIElements/FilterTemplates/DateRowFilterTemplate";
import DocumentPrintSidebar from "../../../UIElements/DocumentPrintSidebar";
import DropDownTemplate from "../../../UIElements/FilterTemplates/DropDownTemplate";
import EnumsContext from "../../../../context/enums-context";
import PaymentSideBar from "../../../UIElements/Sidebars/PaymentSidebar";
import useApi from "../../../../Utils/BackendClient";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import useGetEnums from "../../../../Utils/EnumsUtils";
import { useIsMobile } from "../../../../Utils/ResizeUtils";
import { useLocation, useNavigate } from "react-router-dom";

import { Button } from "primereact/button";
import { Chip } from "primereact/chip";
import { Column } from "primereact/column";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { SplitButton } from "primereact/splitbutton";

import commonStyle from "../../CommonStyles.module.css";

const ExternalActs = () => {

    const buttonRef = useRef();
    const ctx = useContext(EnumsContext);
    const isMobile = useIsMobile();
    const location = useLocation();
    const navigate = useNavigate();
    const toast = useRef();

    const { deleteExternalAct, fetchExternalActs, finalizeExternalAct } = useApi();

    const [externalacts, setExternalActs] = useState(null);
    const [lazyState, setlazyState] = useState({
        first: 0,
        rows: 10,
        page: 1,
        sortField: null,
        sortOrder: 1,
        filters: {
            client: { value: null, matchMode: 'equal' },
            partner: { value: null, matchMode: 'equal' },
            act_date: { value: null, matchMode: 'btw' },
            pay_status: { value: null, matchMode: 'equal' },
            status: { value: null, matchMode: 'equal' }
        }
    });
    const [loading, setLoading] = useState(true);
    const [docPrintSidebarVisible, setDocPrintSidebarVisible] = useState(false);
    const [reloadData, setReloadData] = useState(true);
    const [selectedItem, setSelectedItem] = useState(null);
    const [showFilters, setShowFilters] = useState(false);
    const [tableFilters, setTableFilters] = useState(
        {
            client: { value: null, matchMode: 'equal' },
            partner: { value: null, matchMode: 'equal' },
            act_date: { value: null, matchMode: 'btw' },
            pay_status: { value: null, matchMode: 'equal' },
            status: { value: null, matchMode: 'equal' }
        }
    );
    const [totalRecords, setTotalRecords] = useState(0);
    const [visible, setVisible] = useState(false);

    const enumTypes = useMemo(() => ["clients", "partners", "divisions", "pay_statuses"], []);

    useGetEnums(enumTypes);

    const getDivisionLabel = useEnumLabel(ctx.enums.divisions.data);
    const getClientLabel = useEnumLabel(ctx.enums.clients.data);
    const getPayStatusLabel = useEnumLabel(ctx.enums.pay_statuses.data);
    const getPartnerLabel = useEnumLabel(ctx.enums.partners.data);

    useEffect(() => {
        if (location.state?.toast) {
            toast.current.show(location.state.toast);

            location.state.toast = null;
            navigate(location.pathname, { replace: true, state: location.state });
        }

    }, [location.state, location, navigate]);

    useEffect(() => {
        const fetchData = async () => {

            let state = lazyState;

            if (location.state?.pageState) {

                state = location.state?.pageState;
                setlazyState(location.state?.pageState);

                location.state.pageState = null;

                navigate(location.pathname, { replace: true, state: location.state });
            }

            const response = await fetchExternalActs(state);

            if (response.status === 200) {
                setTotalRecords(response.data.count);
                setExternalActs(response.data.results);
            }
            else {
                toast.current.show({ severity: "error", summary: "Помилка завантаження списку актів", detail: "Помилка сервера " + response.status, life: 3000 });

                setExternalActs([]);
            }

            setLoading(false);
        }

        fetchData();

    }, [fetchExternalActs, lazyState, location, navigate, reloadData]);

    const onPage = (event) => {
        event.page = event.page + 1;
        setlazyState(event);
    };

    const onSort = (event) => {
        event.page = lazyState.page;
        setlazyState(event);
    }

    const onFilter = (event) => {
        setTableFilters(event.filters);
    }

    const filterApply = () => {
        const editedLazyState = lazyState;
        editedLazyState.page = 1;
        editedLazyState.filters = tableFilters;
        setlazyState(editedLazyState);
        setReloadData(!reloadData)
    }

    const clearFilter = (paramName, value) => {
        setlazyState(prevState => ({
            ...prevState,
            filters: {
                ...prevState.filters,
                [paramName]: {
                    ...prevState.filters[paramName],
                    value: value
                }
            }
        }));
    }

    const clearFilterFromChips = (paramName, value) => {
        clearFilter(paramName, value);
        setTableFilters(prevState => ({
            ...prevState,
            [paramName]: {
                value: value
            }
        }));
    }

    const formatFilterChips = () => {

        const getChangedValue = (filterKey, value) => {
            if (filterKey === "partner") {
                return getPartnerLabel(value);
            }
            else if (filterKey === "client") {
                return getClientLabel(value);
            }
            else if (filterKey === "pay_status") {
                return getPayStatusLabel(value);
            }
            else if (filterKey === "status") {
                return actStatuses[value];
            }
            else if (filterKey === "act_date") {
                let splittedValues = value.toString().split(',');
                for (let i = 0; i < splittedValues.length; i++) {
                    splittedValues[i] = new Date(splittedValues[i]).toLocaleDateString('ua-UA', { day: '2-digit', month: '2-digit', year: 'numeric' });
                }
                value = splittedValues.join('-');
            }

            return value;
        };

        return (
            <div className="flex flex-wrap gap-2">
                {Object.keys(lazyState.filters).map((filterKey) => {
                    const filter = lazyState.filters[filterKey];

                    if (filter.value && filter.value !== "") {
                        const translatedKey = Translate(filterKey);
                        const changedValue = getChangedValue(filterKey, filter.value);

                        return (
                            <Chip
                                key={filterKey}
                                label={`${translatedKey}: ${changedValue}`}
                                removable
                                onRemove={() => clearFilterFromChips(filterKey, null)}
                            />
                        );
                    }
                    return null;
                })}
            </div>
        );
    };

    const DeleteButtonHandler = async (rowData) => {

        const response = await deleteExternalAct(rowData.id);

        if (response.status === 204) {
            toast.current.show({ severity: "success", summary: 'Видалення', detail: 'Акт успішно видалено', life: 3000 });
        }
        else if (response.status === 404) {
            toast.current.show({ severity: "error", summary: "Помилка видалення", detail: "Акту " + rowData.id + " не знайдено", life: 3000 });
        }
        else if (response.status === 405) {
            toast.current.show({ severity: "error", summary: "Помилка видалення", detail: "Акт " + rowData.id + "фінлізовано і не може бути видалено", life: 3000 });
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка видалення", detail: "Помилка сервера " + response.status, life: 3000 });
        }

        setReloadData(!reloadData);
    }

    const FinalizeActHandler = async (rowData) => {

        const response = await finalizeExternalAct(rowData.id);

        if (response.status === 200) {
            toast.current.show({ severity: 'success', summary: 'Фіналізація', detail: 'Акт фіналізовано', life: 3000 });
        }
        else if (response.status === 404) {
            toast.current.show({ severity: "error", summary: "Помилка фіналізації", detail: "Акту " + rowData.id + " не знайдено", life: 3000 });
        }
        else if (response.status === 405) {
            toast.current.show({ severity: "error", summary: "Помилка фіналізації", detail: "Акт " + rowData.id + " уже фіналізовано", life: 3000 });
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка фіналізації", detail: "Помилка сервера " + response.status, life: 3000 });
        }

        setReloadData(!reloadData);
    }

    const confirmDelete = (event, rowData) => {
        confirmDialog({
            group: 'headless',
            header: 'Підтвердження',
            message: 'Підтвердіть видалення акту',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Так",
            rejectLabel: "Hi",
            defaultFocus: 'accept',
            accept: () => { DeleteButtonHandler(rowData) }
        });
    }

    const confirmFinalize = (event, rowData) => {
        confirmDialog({
            group: 'headless',
            header: 'Підтвердження',
            message: 'Після фіналізації акту, буде відсутня можливість його редагування',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Так",
            rejectLabel: "Hi",
            defaultFocus: 'accept',
            accept: () => { FinalizeActHandler(rowData) }
        });
    }

    const toolbarLeftTemplate = () => {
        return (isMobile && <Button icon={`${!showFilters ? "pi pi-filter" : "pi pi-filter-slash"}`} severity="secondary" outlined onClick={() => setShowFilters(!showFilters)} />)
    }

    const handleMobileFilterChange = (key, value) => {
        setTableFilters((prevFilters) => ({
            ...prevFilters,
            [key]: { ...prevFilters[key], value: value }
        }));
    }

    const clearMobileFilters = () => {
        setTableFilters({
            client: { value: null, matchMode: 'equal' },
            partner: { value: null, matchMode: 'equal' },
            act_date: { value: null, matchMode: 'btw' },
            pay_status: { value: null, matchMode: 'equal' },
            status: { value: null, matchMode: 'equal' }
        });

        setlazyState(prevState => ({
            ...prevState,
            filters: {
                client: { value: null, matchMode: 'equal' },
                partner: { value: null, matchMode: 'equal' },
                act_date: { value: null, matchMode: 'btw' },
                pay_status: { value: null, matchMode: 'equal' },
                status: { value: null, matchMode: 'equal' }
            }
        }));
    }

    const EditExternalActHandler = rowData => {
        const route = '/externalacts/editexternalact/' + rowData.id;
        navigate(route, { state: { id: rowData.id, pageState: lazyState } });
    }

    const tableHeader = (
        <div className="flex justify-content-between align-items-center w-full">
            {formatFilterChips()}
        </div>
    );

    const toolbarRightTemplate = () => {
        return (<div className="flex flex-wrap gap-2">
            <Button label="Додати партнерський акт" severity="success" className={commonStyle.addButton} onClick={() => navigate('/externalacts/newexternalact')} />
        </div>)
    }

    const formatAdditionalButtons = (rowData) => {
        let buttons = [];
        if (rowData.status !== "FINALIZED") {
            buttons.push({
                label: 'Фіналізувати',
                icon: 'pi pi-lock',
                command: (event) => { confirmFinalize(event, rowData) }
            });

            buttons.push({
                label: 'Видалити',
                icon: 'pi pi-trash',
                command: (event) => { confirmDelete(event, rowData) }
            });
        }
        else {
            if (rowData.pay_status !== "PAYED" && !rowData.partner_is_payment_receiver) {
                buttons.push({
                    label: 'Оплатити',
                    icon: 'pi pi-money-bill',
                    command: () => {
                        setVisible(true);
                        setSelectedItem(rowData);
                    }
                });
            }

            /*buttons.push({
                label: 'Оформити повернення',
                icon: 'pi pi-directions-alt',
                command: (event) => { console.log(rowData) }
            }); */
        }

        if (rowData.templates?.length > 0) {
            buttons.push({
                label: 'Друкувати документи',
                icon: 'pi pi-print',
                command: () => {
                    setDocPrintSidebarVisible(true);
                    setSelectedItem(rowData);
                }
            })
        };

        buttons = buttons.length > 0 ? buttons : null;
        return buttons
    };

    const actionBodyTemplate = (rowData) => {
        const buttons = formatAdditionalButtons(rowData);

        const buttonLabel = rowData.status !== "FINALIZED" ? "Редагувати" : "Деталі акту";
        const buttonIcon = rowData.status !== "FINALIZED" ? "pi pi-pencil" : "pi pi-eye";

        return (
            <>
                {buttons !== null ? (
                    <SplitButton
                        label={!isMobile ? buttonLabel : null}
                        icon={buttonIcon}
                        onClick={() => EditExternalActHandler(rowData)}
                        model={buttons}
                        text
                        ref={buttonRef} // Set the ref here
                    />
                ) : (
                    <Button
                        label={!isMobile ? buttonLabel : null}
                        icon={buttonIcon}
                        onClick={() => EditExternalActHandler(rowData)}
                        text
                    />
                )}
            </>
        );
    };

    const mobileTableHeader = rowData => {
        return (
            showFilters && <div className="grid">
                <div className="col-12 mt-3">
                    <FloatLabel>
                        <Dropdown
                            value={tableFilters.client.value}
                            onChange={e => handleMobileFilterChange("client", e.value)}
                            options={ctx.enums.clients.data}
                            placeholder="Виберіть значення"
                            className="p-column-filter w-full"
                            showClear
                        />
                        <label>Клієнт</label>
                    </FloatLabel>
                </div>
                <div className="col-12 mt-3">
                    <FloatLabel>
                        <Dropdown
                            value={tableFilters.partner.value}
                            onChange={e => handleMobileFilterChange("partner", e.value)}
                            options={ctx.enums.partners.data}
                            placeholder="Виберіть значення"
                            className="p-column-filter w-full"
                            showClear
                        />
                        <label>Партнер</label>
                    </FloatLabel>
                </div>
                <div className="col-12 mt-3">
                    <FloatLabel>
                        <Dropdown
                            value={actStatuses[tableFilters.status.value]}
                            onChange={e => handleMobileFilterChange("status", findKeyByValue(actStatuses, e.value))}
                            options={Object.values(actStatuses)}
                            placeholder="Виберіть значення"
                            className="p-column-filter w-full"
                            showClear
                        />
                        <label>Статус</label>
                    </FloatLabel>
                </div>
                <div className="col-12 mt-3">
                    <FloatLabel>
                        <Dropdown
                            value={tableFilters.pay_status.value}
                            onChange={e => handleMobileFilterChange("pay_status", e.value)}
                            options={ctx.enums.pay_statuses.data}
                            placeholder="Виберіть значення"
                            className="p-column-filter w-full"
                            showClear
                        />
                        <label>Статус оплати</label>
                    </FloatLabel>
                </div>
                <div className="col-6 flex justify-content-center">
                    <Button severity="secondary" outlined style={{ width: "98%" }} onClick={() => clearMobileFilters()} label="Очистити фільтри" />
                </div>
                <div className="col-6 flex justify-content-center">
                    <Button severity="success" outlined style={{ width: "98%" }} onClick={() => filterApply()} label="Застосувати" />
                </div>
            </div>
        );
    }

    const mobileActBody = rowData => {

        const color = rowData.pay_status === "PAYED" || rowData.pay_status === "NO_PAYMENT_REQUIRED" ? "#03C04A" : "#EF4444";

        return (
            <div className="flex justify-content-between flex-wrap">
                <div className="grid w-8">
                    <div className="col-2 flex justify-content-center align-items-center">
                        <ActStatusCircle rowData={rowData} />
                    </div>
                    <div className="col-10">
                        <div className="flex-column">
                            <div>Акт №{rowData.act_number}</div>
                            <div><i className="pi pi-clock" /> {rowData.act_date}</div>
                            <div style={{ color }}><i className={`pi ${rowData.pay_status === "PAYED" || rowData.pay_status === "NO_PAYMENT_REQUIRED" ? "pi-check" : "pi-times"}`} /> {getPayStatusLabel(rowData.pay_status)}</div>
                            {rowData.partner_is_payment_receiver ? <div>Партнер отримує оплату</div> : null}
                            <div><i className="pi pi-user" /> {getClientLabel(rowData.client) ?? "Клієнта не вказано"}</div>
                            <div><i className="pi pi-percentage" /> {rowData.commission_percent * 100}</div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-content-center align-items-center">
                    {actionBodyTemplate(rowData)}
                </div>
            </div>
        )
    }

    console.log(ctx);

    return (
        <>
            <Toast ref={toast} />
            <Toolbar start={toolbarLeftTemplate} end={toolbarRightTemplate} />
            <div className='grid'>
                <div className='col-12 justify-content-center'>
                    {!isMobile && <DataTable value={externalacts} header={tableHeader} stripedRows lazy rows={lazyState.rows} paginator onPage={onPage} totalRecords={totalRecords} rowsPerPageOptions={[10, 20, 50]} first={lazyState.first}
                        removableSort onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                        dataKey="id" onFilter={onFilter} filters={lazyState.filters} loading={loading} emptyMessage="Актів не знайдено" >
                        <Column field="act_number" header="Номер акту" sortable style={{ width: '6%' }} />
                        <Column field="act_date" header="Дата акту" sortable filter filterElement={DateRowFilterTemplate} onFilterApplyClick={filterApply} filterMatchModeOptions={dataFilterMatchModeOptions}
                            onFilterClear={() => clearFilter("date", null)} body={(rowData) => new Date(rowData.act_date).toLocaleDateString('ua-UA', { day: '2-digit', month: '2-digit', year: 'numeric' })} />
                        <Column field="partner" header="Постачальник" sortable filter filterElement={(options) => DropDownTemplate(options, ctx.enums.partners.data)} onFilterApplyClick={filterApply}
                            onFilterClear={() => clearFilter("partner", null)} showFilterMatchModes={false} body={rowData => getPartnerLabel(rowData.partner)} />
                        <Column field="client" header="Клієнт" sortable filter filterElement={(options) => DropDownTemplate(options, ctx.enums.clients.data)} onFilterApplyClick={filterApply}
                            onFilterClear={() => clearFilter("client", null)} showFilterMatchModes={false} body={rowData => getClientLabel(rowData.client)} />
                        <Column field="pay_due_date" header="Дата оплати" body={(rowData) => new Date(rowData.act_date).toLocaleDateString('ua-UA', { day: '2-digit', month: '2-digit', year: 'numeric' })} />
                        <Column field="partner_is_payment_receiver" header="Отримувач оплати" body={rowData => rowData.partner_is_payment_receiver ? "Партнер" : getDivisionLabel(rowData.division)} />
                        <Column field="commission_percent" header="Комісія" body={rowData => `${rowData.commission_percent * 100}%`} style={{ width: '4%' }} />
                        <Column field="amount_UAH" header="Сума акту" body={rowData => formatCurrency(rowData.amount_UAH, "UAH")} />
                        <Column field="pay_status" header="Статус оплати" filter filterElement={(options) => DropDownTemplate(options, ctx.enums.pay_statuses.data)} onFilterApplyClick={filterApply}
                            onFilterClear={() => clearFilter("pay_status", null)} showFilterMatchModes={false} body={rowData => getPayStatusLabel(rowData.pay_status)} sortable style={{ width: '9%' }} />
                        <Column field="status" header="Статус" filter filterElement={(options) => DropDownTemplate(options, actStatuses)} onFilterApplyClick={filterApply}
                            onFilterClear={() => clearFilter("status", null)} showFilterMatchModes={false} body={rowData => <ActStatusCircle rowData={rowData} />} sortable style={{ width: '5%' }} />
                        <Column field="action" body={actionBodyTemplate} />
                    </DataTable>}
                    {isMobile && <DataTable value={externalacts} header={mobileTableHeader} stripedRows lazy rows={lazyState.rows} paginator onPage={onPage} onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                        first={lazyState.first} loading={loading} totalRecords={totalRecords} rowsPerPageOptions={[10, 20, 50]} paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                        dataKey="id" onFilter={onFilter} filters={lazyState.filters} emptyMessage="Актів не знайдено">
                        <Column field="act_number" headerStyle={{ display: 'none' }} body={mobileActBody} />
                    </DataTable>}
                </div>
                <ConfirmDialog group="headless" />
            </div>
            <PaymentSideBar visible={visible} onHide={() => setVisible(false)} onMessage={(message) => toast.current.show(message)} data={selectedItem} moneyMovementType="INCOME" reloadData={() => setReloadData(!reloadData)} isExternalAct={true} />
            <DocumentPrintSidebar sbVisible={docPrintSidebarVisible} onHide={() => setDocPrintSidebarVisible(false)} actData={selectedItem} toast={toast} />
        </>
    );
}

export default ExternalActs;